import { render } from "./AdminSitesView.vue?vue&type=template&id=3c2144cc&scoped=true"
import script from "./AdminSitesView.vue?vue&type=script&lang=js"
export * from "./AdminSitesView.vue?vue&type=script&lang=js"

import "./AdminSitesView.vue?vue&type=style&index=0&id=3c2144cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2144cc"]])

export default __exports__